import { render, staticRenderFns } from "./prize-activity.vue?vue&type=template&id=4be5a576&scoped=true&"
import script from "./prize-activity.vue?vue&type=script&lang=js&"
export * from "./prize-activity.vue?vue&type=script&lang=js&"
import style0 from "./prize-activity.vue?vue&type=style&index=0&id=4be5a576&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be5a576",
  null
  
)

export default component.exports